import { Chip } from '@mui/material';

interface Props {
  role: string;
}

const UserRoleChip = ({ role }: Props) => {
  const roleColors: { [key: string]: { backgroundColor: string; color: string } } = {
    SuperAdmin: { backgroundColor: '#321d1d', color: '#FF4D4F' },
    IsoManager: { backgroundColor: '#342c1a', color: '#dda705' },
    Broker: { backgroundColor: '#342c1a', color: '#dda705' },
    Merchant: { backgroundColor: '#1a2628', color: '#597EF7' },
    Investor: { backgroundColor: '#1a2721', color: '#52C41A' },
    Funder: { backgroundColor: '#1a2721', color: '#FF69B4' },
    PreUnderwriter:{backgroundColor: '#222130', color: '#6a5acd'},
    Underwriter:{backgroundColor: '#222130', color: '#6a5acd'}
  };

  const { backgroundColor, color } = roleColors[role] || { backgroundColor: '#9e9e9e', color: '#000000' };

  return <Chip key={role} size="small" variant="light" sx={{ height: '20px', backgroundColor, color }} label={role} />;
};
export default UserRoleChip;
